// REACT, ROUTER, REDUX
import React from "react";

// FUNCTIONS
import { formatDate } from "../../functions/formatDate";

// INTERFACES
import { ReceiptUnitProps } from "../../interface/propTypesInterface";

export default function ReceiptUnit(props: ReceiptUnitProps) {
  const { id, label, mode, output, timestamp, deleteCallback } = props;

  // ::::: USEHOOKS :::::

  // ::::: HANDLER FUNCTIONS :::::
  const handleDelete = (id: string) => {
    deleteCallback(id);
  };

  try {
    return (
      <article className="receipt" key={id}>
        <div className="receipt__label">
          <h5>{label}: </h5>
          <h6>{mode}</h6>
          <button
            className="close-button small dont-exit"
            onClick={() => handleDelete(id)}
            // tabIndex={show ? 0 : -1} //meTODO fix this
          ></button>
        </div>
        <ul className="receipt__output">
          {output.map((val, i) => {
            return (
              <li className="receipt__output-item" key={`${val.name}_${i}`}>
                <p>{val.name}</p>
                <p>{val.value}</p>
                <p>{val.unit}</p>
              </li>
            );
          })}
        </ul>
        <time className="receipt__timestamp">{formatDate(timestamp)}</time>
      </article>
    );
  } catch (error) {
    return (
      <article className="receipt">
        <div className="receipt__label">
          <h5 style={{ color: "var(--color-error)" }}>Receipt corrupted</h5>
          {/* <button onClick={() => handleDelete(receipt)}>x</button> */}
        </div>
        <ul className="receipt__output">
          <li style={{ textAlign: "center" }}>
            Your can either delete the corrupted receipt, or export your data
            and send it to our superuser in the feedback form below
          </li>
        </ul>
        <time
          className="receipt__timestamp"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <button
            className="rectangular-button smaller inverse-color"
            style={{ backgroundSize: "40rem" }}
            type="button"
            onClick={() => handleDelete(id)}
          >
            Delete corrupted receipt
          </button>
        </time>
      </article>
    );
  }
}
